import Vue from "vue";
import Router from "vue-router";
import stores from "../store/store";

// Containers
const TheContainer = () => import("@/containers/TheContainer");

// Views
const Login = () => import("@/views/Login");
const loginToken = () => import("@/views/loginToken");
const loker = () => import("@/views/loker");
const dokumenLoker = () => import("@/views/dokumenLoker/dokumenLoker");
const masterUser = () => import("@/views/hcms/master/user/user");
const KPI = () => import("@/views/KPI.vue");
const test = () => import("@/views/test.vue");

// HCMS
const DashboardHcms = () => import("@/views/dashboard/DashboardHcms");
const masterDivisi = () => import("@/views/hcms/master/divisiNew/divisiNew");
const masterGaji = () => import("@/views/hcms/master/gaji/gajiPokok");
// const masterPosisi = () => import("@/views/hcms/master/posisi/posisi");
const masterPelanggaran = () => import("@/views/hcms/master/pelanggaran/pelanggaran");
const masterAsuransi = () => import("@/views/hcms/master/asuransi/asuransi");
const masteRole = () => import("@/views/hcms/master/role/role");
const periodePenggajian = () => import("@/views/hcms/master/periodePenggajian/periodePenggajian");
const roleUser = () => import("@/views/hcms/master/roleUser/roleUser");
const masterKategoriDenda = () => import("@/views/hcms/master/kategoriDenda/kategoriDenda");
// const masterTunjanganTetap = () => import("@/views/hcms/master/tunjanganTetap");
const masterTunjanganTidakTetap = () => import("@/views/hcms/master/tunjanganTidakTetap/tunjanganTidakTetap");
const masterTunjangan = () => import("@/views/hcms/master/tunjangan/tunjangan");
// const masterPerusahaanPenempatan = () =>
//   import("@/views/hcms/master/perusahaanPenempatan/perusahaanPenempatan");
const masterDokAdministrasi = () => import("@/views/hcms/master/dokAdministrasi/dokAdministrasi");
const masterTahapanSeleksi = () => import("@/views/hcms/master/tahapanSeleksi/tahapanSeleksi");
const lowonganKerja = () => import("@/views/hcms/lowonganKerja/lowonganKerja");
const pelamarKerja = () => import("@/views/hcms/pelamarKerja/pelamar");
const pelamarKerjaDitolak = () => import("@/views/hcms/pelamarKerja/pelamarKerjaDitolak/pelamarKerjaDitolak");
const kelengkapanPelamar = () => import("@/views/hcms/pelamarKerja/kelengkapanPelamar/kelengkapanPelamar");

const tahapSeleksiPelamar = () => import("@/views/hcms/tahapSeleksiPelamar/tahapSeleksiPelamar");

// const karyawan = () => import("@/views/hcms/karyawan/karyawan");
const karyawan = () => import("@/views/hcms/karyawan/karyawan/karyawan");
const detailKaryawan = () => import("@/views/hcms/karyawan/detailKaryawan/detailKaryawan");
const editKaryawan = () => import("@/views/hcms/karyawan/editKaryawan");
const perintahKerja = () => import("@/views/hcms/karyawan/perintahKerja/perintahKerja");
const perjanjianKerja = () => import("@/views/hcms/karyawan/perjanjianKerja/perjanjianKerja");
const persetujuan = () => import("@/views/hcms/karyawan/persetujuan/persetujuan");
const konfirmasi = () => import("@/views/hcms/suratKonfirmasi/suratKonfirmasi");
const AssesmentKaryawan = () => import("@/views/hcms/KPI/KPI/penilaian.vue");
const Warning = () => import("@/views/hcms/KPI/warning/warning.vue");
const potonganAsuransi = () => import("@/views/hcms/potonganAsuransi/potonganAsuransi");

const masterKategoriPenilaian = () => import("@/views/hcms/master/kategoriPenilaian/kategoriPenilaian");

const masterPenilaian = () => import("@/views/hcms/master/penilaian/penilaian");
const masterPotongan = () => import("@/views/hcms/master/potongan/potongan");

const masterKeteranganIjin = () => import("@/views/hcms/master/keteranganIjin/keteranganIjin");

const masterCuti = () => import("@/views/hcms/master/cuti/cuti");

const masterShift = () => import("@/views/hcms/master/shift/shift");
const masterJabatan = () => import("@/views/hcms/master/jabatan/jabatan");
const masterLembur = () => import("@/views/hcms/master/lembur/lembur");
const masterKeteranganHapus = () => import("@/views/hcms/master/keteranganHapus/keteranganHapus");

// const masterMitraPusat = () => import("@/views/hcms/master/mitraPusat");

const masterMitra = () => import("@/views/hcms/master/mitraNew/mitraNew");
// const masterMitraPembantu = () =>
//   import("@/views/hcms/master/mitraPembantu/mitraPembantu");
const kecelakaanKerja = () => import("@/views/hcms/kecelakaanKerja/kecelakaanKerja");

const rekapAbsensi = () => import("@/views/hcms/absensi/rekapAbsensi/rekapAbsensi");
const kelolaCuti = () => import("@/views/hcms/absensi/pengajuanCuti/pengajuanCuti");
const rubahShift = () => import("@/views/hcms/absensi/perubahanShift/perubahanShift");
const rekapGaji = () => import("@/views/Laporan/rekapGaji/rekapGaji");
const laporanGaji = () => import("@/views/Laporan/laporanGaji/laporanGaji");
const laporanTHR = () => import("@/views/Laporan/THR/THR");
const laporanLembur = () => import("@/views/Laporan/Lembur/Lembur");
const pengajuanLembur = () => import("@/views/hcms/absensi/pengajuanLembur/pengajuanLembur");
// const History = () => import("@/views/Laporan/Karyawan/karyawan");
const mutasi = () => import("@/views/hcms/karyawan/mutasi/mutasi");
const totalPotongan = () => import("@/views/Laporan/totalPotongan/totalPotongan");
const jadwal = () => import("@/views/hcms/jadwal/jadwal");
const perform = () => import("@/views/hcms/performance/performance.vue");
const importE = () => import("@/views/import/importEmployee.vue");
const tools_bday = () => import("@/views/tools/Bday/bday.vue");
const tools_Appreciation = () => import("@/views/tools/Appreciation/Appreciation.vue");
const tools_Warning = () => import("@/views/tools/Warning/Warning.vue");
const announcement = () => import("@/views/tools/announcement/announcement.vue");
const lateFines = () => import("@/views/tools/lateAttendanceFines/lateFines.vue");
const tax = () => import("@/views/tools/tax/tax.vue");
Vue.use(Router);

const router = new Router({
  mode: "history", // https://router.vuejs.org/api/#mode
  linkActiveClass: "open active",
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    // {
    //   path: "/hubungiKami",
    //   name: "Contact Us",
    //   component: contactUs,
    //   meta: {
    //     requiresAuth: false,
    //   },
    // },
    // {
    //   path: "/requestDemo",
    //   name: "Request Demo",
    //   component: requestDemo,
    //   meta: {
    //     requiresAuth: false,
    //   },
    // },

    // Backoffice
    {
      path: "/login",
      name: "Login",
      component: Login,
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: "/test",
      name: "test",
      component: test,
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: "/penilaianKinerja",
      name: "KPI",
      component: KPI,
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: "/loker",
      name: "Loker",
      component: loker,
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: "/loginToken",
      name: "Login Token",
      component: loginToken,
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: "/dokumenLoker/:postLokerId",
      name: "Dokumen Loker",
      component: dokumenLoker,
      meta: {
        requiresAuth: false,
      },
      beforeRouteUpdate(to, from, next) {
        console.log(to);
        if (to.path == "/dokumenLoker/:postLokerId") {
          next({
            path: "/DokumenLoker/",
          });
        }
      },
    },

    {
      path: "/",
      redirect: "/dashboard",
      name: "Admin",
      component: TheContainer,
      children: [
        {
          path: "/dashboard",
          name: "DashboardHcms",
          component: DashboardHcms,
          meta: {
            requiresAuth: true,
            role: "admin",
          },
        },
        {
          path: "/user",
          name: "Master User",
          component: masterUser,
          meta: {
            requiresAuth: true,
            role: "admin",
          },
        },
        {
          path: "/divisi",
          name: "Master Posisi",
          component: masterDivisi,
          meta: {
            requiresAuth: true,
            role: "admin",
          },
        },
        {
          path: "/gaji",
          name: "Master Gaji",
          component: masterGaji,
          meta: {
            requiresAuth: true,
            role: "admin",
          },
        },
        // {
        //   path: "/posisi",
        //   name: "Master Posisi",
        //   component: masterPosisi,
        //   meta: {
        //     requiresAuth: true,
        //     role: "admin",
        //   },
        // },
        {
          path: "/pelanggaran",
          name: "Master Pelanggaran",
          component: masterPelanggaran,
          meta: {
            requiresAuth: true,
            role: "admin",
          },
        },
        {
          path: "/dokAdministrasi",
          name: "Master Dokumen Administrasi Pelamar",
          component: masterDokAdministrasi,
          meta: {
            requiresAuth: true,
            role: "admin",
          },
        },
        {
          path: "/tahapanSeleksi",
          name: "Master Tahapan Seleksi Pelamar",
          component: masterTahapanSeleksi,
          meta: {
            requiresAuth: true,
            role: "admin",
          },
        },

        {
          path: "/kategoriPenilaian",
          name: "Master Kategori Penilaian",
          component: masterKategoriPenilaian,
          meta: {
            requiresAuth: true,
            role: "admin",
          },
        },

        {
          path: "/penilaian",
          name: "Master Penilaian",
          component: masterPenilaian,
          meta: {
            requiresAuth: true,
            role: "admin",
          },
        },
        {
          path: "/overtime",
          name: "Master Lembur",
          component: masterLembur,
          meta: {
            requiresAuth: true,
            role: "admin",
          },
        },
        {
          path: "/potongan",
          name: "Master Potongan",
          component: masterPotongan,
          meta: {
            requiresAuth: true,
            role: "admin",
          },
        },

        {
          path: "/keteranganIjin",
          name: "Master Keterangan Ijin",
          component: masterKeteranganIjin,
          meta: {
            requiresAuth: true,
            role: "admin",
          },
        },

        {
          path: "/keteranganHapus",
          name: "Master Keterangan Hapus / Dipecat",
          component: masterKeteranganHapus,
          meta: {
            requiresAuth: true,
            role: "admin",
          },
        },

        {
          path: "/cuti",
          name: "Master Cuti",
          component: masterCuti,
          meta: {
            requiresAuth: true,
            role: "admin",
          },
        },

        {
          path: "/asuransi",
          name: "Master Asuransi",
          component: masterAsuransi,
          meta: {
            requiresAuth: true,
            role: "admin",
          },
        },

        {
          path: "/periodePenggajian",
          name: "Master Periode Penggajian",
          component: periodePenggajian,
          meta: {
            requiresAuth: true,
            role: "admin",
          },
        },

        {
          path: "/role",
          name: "Master Role",
          component: masteRole,
          meta: {
            requiresAuth: true,
            role: "admin",
          },
        },

        {
          path: "/roleUser",
          name: "Master Role User",
          component: roleUser,
          meta: {
            requiresAuth: true,
            role: "admin",
          },
        },

        {
          path: "/kategoriDenda",
          name: "Master Kategori Denda",
          component: masterKategoriDenda,
          meta: {
            requiresAuth: true,
            role: "admin",
          },
        },

        {
          path: "/tunjangan",
          name: "Master Tunjangan ",
          component: masterTunjangan,
          meta: {
            requiresAuth: true,
            role: "admin",
          },
        },

        // {
        //   path: "/tunjanganTetap",
        //   name: "Master Tunjangan Tetap",
        //   component: masterTunjanganTetap,
        //   meta: {
        //     requiresAuth: true,
        //     role: "admin",
        //   },
        // },

        {
          path: "/tunjanganTidakTetap",
          name: "Master Tunjangan Tidak Tetap",
          component: masterTunjanganTidakTetap,
          meta: {
            requiresAuth: true,
            role: "admin",
          },
        },

        {
          path: "/masterShift",
          name: "Master Shift Karyawan",
          component: masterShift,
          meta: {
            requiresAuth: true,
            role: "admin",
          },
        },
        {
          path: "/masterJabatan",
          name: "Master Jabatan",
          component: masterJabatan,
          meta: {
            requiresAuth: true,
            role: "admin",
          },
        },

        // {
        //   path: "/masterPerusahaanPenempatan",
        //   name: "Master Perusahaan Penempatan",
        //   component: masterPerusahaanPenempatan,
        //   meta: {
        //     requiresAuth: true,
        //     role: "admin",
        //   },
        // },

        {
          path: "/masterMitra",
          name: "Master Cabang",
          component: masterMitra,
          meta: {
            requiresAuth: true,
            role: "admin",
          },
        },

        // {
        //   path: "/masterMitraPembantu",
        //   name: "Master Mitra Pembantu",
        //   component: masterMitraPembantu,
        //   meta: {
        //     requiresAuth: true,
        //     role: "admin",
        //   },
        // },

        {
          path: "/kecelakaanKerja",
          name: "Kecelakaan Kerja",
          component: kecelakaanKerja,
          meta: {
            requiresAuth: true,
            role: "admin",
          },
        },

        {
          path: "/lowonganKerja",
          name: "Lowongan Kerja",
          component: lowonganKerja,
          meta: {
            requiresAuth: true,
            role: "admin",
          },
        },
        {
          path: "/pelamarKerja",
          name: "Pelamar Kerja",
          component: pelamarKerja,
          meta: {
            requiresAuth: true,
            role: "admin",
          },
        },
        {
          path: "/pelamarKerjaDitolak",
          name: "Pelamar Kerja Ditolak",
          component: pelamarKerjaDitolak,
          meta: {
            requiresAuth: true,
            role: "admin",
          },
        },
        {
          path: "/kelengkapanPelamar",
          name: "Kelengkapan Pelamar",
          component: kelengkapanPelamar,
          meta: {
            requiresAuth: true,
            role: "admin",
          },
        },

        {
          path: "/tahapSeleksiPelamar",
          name: "Tahap Seleksi Pelamar",
          component: tahapSeleksiPelamar,
          meta: {
            requiresAuth: true,
            role: "admin",
          },
        },

        {
          path: "/karyawan",
          name: "Karyawan",
          component: karyawan,
          meta: {
            requiresAuth: true,
            role: "admin",
          },
        },

        {
          path: "/detailKaryawan",
          name: "Detail Karyawan",
          component: detailKaryawan,
          meta: {
            requiresAuth: true,
            role: "admin",
          },
        },

        {
          path: "/karyawan/edit/:id",
          name: "Edit Karyawan",
          component: editKaryawan,
          meta: {
            requiresAuth: true,
            role: "admin",
          },
        },

        {
          path: "/kontrak",
          name: "Perintah Kerja",
          component: perintahKerja,
          meta: {
            requiresAuth: true,
            role: "admin",
          },
        },

        {
          path: "/perjanjianKerja",
          name: "Perjanjian",
          component: perjanjianKerja,
          meta: {
            requiresAuth: true,
            role: "admin",
          },
        },

        {
          path: "/suratPersetujuan",
          name: "Persetujuan",
          component: persetujuan,
          meta: {
            requiresAuth: true,
            role: "admin",
          },
        },

        {
          path: "/suratKonfirmasi",
          name: "Konfirmasi",
          component: konfirmasi,
          meta: {
            requiresAuth: true,
            role: "admin",
          },
        },

        {
          path: "/potonganAsuransi",
          name: "Potongan Asuransi",
          component: potonganAsuransi,
          meta: {
            requiresAuth: true,
            role: "admin",
          },
        },
        {
          path: "/mutasi",
          name: "Mutasi Karyawan",
          component: mutasi,
          meta: {
            requiresAuth: true,
            role: "admin",
          },
        },

        {
          path: "/rekapAbsensi",
          name: "Rekap Absensi",
          component: rekapAbsensi,
          meta: {
            requiresAuth: true,
            role: "admin",
          },
        },
        {
          path: "/pengajuanCuti",
          name: "Pengajuan Cuti",
          component: kelolaCuti,
          meta: {
            requiresAuth: true,
            role: "admin",
          },
        },
        {
          path: "/perubahanShift",
          name: "Perubahan Shift",
          component: rubahShift,
          meta: {
            requiresAuth: true,
            role: "admin",
          },
        },
        {
          path: "/laporanGaji",
          name: "Proyeksi Gaji",
          component: laporanGaji,
          meta: {
            requiresAuth: true,
            role: "admin",
          },
        },
        {
          path: "/rekapGaji",
          name: "Rekap Gaji",
          component: rekapGaji,
          meta: {
            requiresAuth: true,
            role: "admin",
          },
        },
        // {
        //   path: "/History",
        //   name: "History Karyawan",
        //   component: History,
        //   meta: {
        //     requiresAuth: true,
        //     role: "admin",
        //   },
        // },
        {
          path: "/totalPotongan",
          name: "Total Potongan",
          component: totalPotongan,
          meta: {
            requiresAuth: true,
            role: "admin",
          },
        },
        {
          path: "/THR",
          name: "Laporan THR",
          component: laporanTHR,
          meta: {
            requiresAuth: true,
            role: "admin",
          },
        },
        {
          path: "/lembur",
          name: "Laporan Lembur",
          component: laporanLembur,
          meta: {
            requiresAuth: true,
            role: "admin",
          },
        },
        {
          path: "/pengajuanLembur",
          name: "Pengajuan Lembur",
          component: pengajuanLembur,
          meta: {
            requiresAuth: true,
            role: "admin",
          },
        },
        {
          path: "/assesmentKaryawan",
          name: "Penilaian Karyawan By Mitra",
          component: AssesmentKaryawan,
          meta: {
            requiresAuth: true,
            role: "admin",
          },
        },
        {
          path: "/warning",
          name: "Warning Letter",
          component: Warning,
          meta: {
            requiresAuth: true,
            role: "admin",
          },
        },
        {
          path: "/jadwal",
          name: "Jadwal",
          component: jadwal,
          meta: {
            requiresAuth: true,
            role: "admin",
          },
        },
        {
          path: "/perform",
          name: "Perform",
          component: perform,
          meta: {
            requiresAuth: true,
            role: "admin",
          },
        },
        {
          path: "/import_data",
          name: "Import",
          component: importE,
          meta: {
            requiresAuth: true,
            role: "admin",
          },
        },
        {
          path: "/logout",
          name: "logout",
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/tools_bday",
          name: "Bday",
          component: tools_bday,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/tools_warning",
          name: "Warning",
          component: tools_Warning,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/tools_appreciation",
          name: "Appreciation",
          component: tools_Appreciation,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/announcement",
          name: "Announ",
          component: announcement,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/late_fines",
          name: "Late Fines",
          component: lateFines,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/tax",
          name: "tax",
          component: tax,
          meta: {
            requiresAuth: true,
          },
        },
      ],
    },
  ],
});

router.beforeEach(async function (to, from, next) {
  let token = stores.state.login_token;
  let isAdmin = stores.state.role_aktif ? stores.state.role_aktif.kodeRole == "super" : false;
  stores.commit("set_last_query", to);
  if (
    to.matched.some((r) => {
      if (r.meta.requiresAuth == true) {
        if (token != null) {
          if (r.path == "/logout") {
            stores.commit("logout");
            next("login");
          } else {
            const restrictedPaths = ["/THR", "/rekapGaji", "/LaporanGaji"];
            if (!isAdmin && restrictedPaths.includes(to.path)) {
              return next("/jadwal"); // redirect to an access denied page or home
            }
            next();
          }
        } else {
          next("login");
        }
      } else {
        if (token) {
          if (r.path == "login") {
            next("/");
          } else {
            const restrictedPaths = ["/THR", "/rekapGaji", "/LaporanGaji"];
            if (!isAdmin && restrictedPaths.includes(to.path)) {
              return next("/jadwal");
            }
            next();
          }
        } else {
          next();
        }
      }
    })
  );
});

export default router;
